import { Controller } from '@hotwired/stimulus';

// 重い集計セクションを非同期(ajax)で読み込み、取得した HTML で差し替える (#1832)
// 各セクションが並行ロードされるため、初回描画がブロックされない。
export default class extends Controller {
  static values = { url: String };

  connect() {
    // paginator リンク(.js-async-paginator 内)の click を横取りして
    // フラグメントを差し替える。委譲なので innerHTML 差し替え後も有効。
    this.onClick = this.onClick.bind(this);
    this.element.addEventListener('click', this.onClick);
    this.load(this.urlValue);
  }

  disconnect() {
    this.element.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    const link = event.target.closest('.js-async-paginator a[href]');
    if (!link || !this.element.contains(link)) return;

    event.preventDefault();
    this.load(link.getAttribute('href'));
  }

  reload() {
    this.load(this.urlValue);
  }

  async load(url) {
    try {
      const res = await fetch(url, {
        headers: { Accept: 'text/html', 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      this.element.innerHTML = await res.text();
    } catch (_e) {
      this.renderError();
    }
  }

  renderError() {
    this.element.innerHTML = `
      <div class="alert alert-warning d-flex justify-content-between align-items-center">
        <span>読み込みに失敗しました</span>
        <button type="button" class="btn btn-sm btn-outline-secondary" data-action="async-section#reload">再読み込み</button>
      </div>`;
  }
}
